import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import { PublicationFilter } from '../models/publication-filter';
import { Publication } from '../../shared/models/publication';

export const publicationListActionTypes = {
  TOGGLE_SEARCH: type('[publications] Toggle Search Form'),
  QUICK_SEARCH: type('[publications] Quick Search'),
  SEARCH: type('[publications] Search'),
  CHANGE_PAGE_SIZE: type('[publications] Change Page Size'),
  PAGE_TO: type('[publications] Page To'),
  ORDER_BY: type('[publications] Order By'),
  LOAD: type('[publications] Load'),
  LOAD_SUCCESS: type('[publications] Load Success'),
  LOAD_FAIL: type('[publications] Load Fail'),
  SELECT_PAGE: type('[publications] Select Page'),
  UNSELECT_PAGE: type('[publications] Unselect Page'),
  TOGGLE_SELECTION: type('[publications] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[publications] Toggle Selection Tags'),
  CLEAR: type('[publications] Clear Data')
};


export class ToggleSearchPublicationsAction implements Action {
  readonly type = publicationListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}
export class QuickSearchPublicationsAction implements Action {
  readonly type = publicationListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}
export class SearchPublicationsAction implements Action {
  readonly type = publicationListActionTypes.SEARCH;
  constructor(public payload?: PublicationFilter) {}
}
export class ChangePublicationsPageSizeAction implements Action {
  readonly type = publicationListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}
export class PagePublicationsToAction implements Action {
  readonly type = publicationListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}
export class OrderPublicationsByAction implements Action {
  readonly type = publicationListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}
export class LoadPublicationsAction implements Action {
  readonly type = publicationListActionTypes.LOAD;
  constructor() {}
}
export class LoadPublicationsSuccessAction implements Action {
  readonly type = publicationListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<Publication>) {}
}
export class LoadPublicationsFailAction implements Action {
  readonly type = publicationListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectPublicationsPageAction implements Action {
  readonly type = publicationListActionTypes.SELECT_PAGE;
  constructor() {}
}
export class UnselectPublicationsPageAction implements Action {
  readonly type = publicationListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ClearPublicationsAction implements Action {
  readonly type = publicationListActionTypes.CLEAR;
  constructor() {}
}
